import get from 'lodash/get';
import merge from 'lodash/merge';

import baseTheme, * as themes from './themes';

const enhanceTheme = (
  initialTheme,
  { themeIsActive, themePrimaryColor, themeTextColor, themeBackgroundImage },
) => {
  let theme = merge({}, initialTheme);
  if (!themeIsActive) return theme;
  if (themePrimaryColor) theme = merge(theme, { color: { primary: themePrimaryColor } });
  if (themeTextColor) theme = merge(theme, { color: { surveyText: themeTextColor } });

  const background = get(themeBackgroundImage, 'originalUrl', null);
  theme = merge(theme, { asset: { background } });
  return theme;
};

export default function resolveEffectiveTheme({
  survey,
  orgOptions = {},
  defaultThemeName = 'inactive',
}) {
  if (orgOptions.themeIsActive) {
    return enhanceTheme(baseTheme, orgOptions);
  }
  const selectedSurveyTheme = themes[survey ? survey.theme : defaultThemeName];
  return merge({}, baseTheme, selectedSurveyTheme);
}
